import api from './client';

export { default as api } from './client';
export * from './client';

export { authService } from './authService';
export { roleService } from './roleService';
export { userService } from './userService';
export { membershipService } from './membershipService';
export { medicalCertificateService } from './medicalCertificateService';
export { documentService } from './documentService';
export { parentService } from './parentService';
export { courseService } from './courseService';
export { dashboardService } from './dashboardService';
export { commonService } from './commonService';
export { groupService } from './groupService';
export { subscriptionService } from './subscriptionService';
export { rollCallService } from './rollCallService';
export { courseOfferService } from './courseOfferService';
export { registrationService } from './registrationService';
export { auditLogService } from './auditLogService';
export { rentableItemService } from './rentableItemService';
export { rentalService } from './rentalService';
export { settingsService } from './settingsService';
export { emailTemplateService } from './emailTemplateService';
export { athleteAccessService } from './athleteAccessService';
export { portalService } from './portalService';
export { maintenanceService } from './maintenanceService';
export { notificationService } from './notificationService';
export { locationService } from './locationService';
export { appointmentService } from './appointmentService';
export { revenueService } from './revenueService';
export { bookingService } from './bookingService';
export { logService } from '../logService';

export default api;
